<template>
  <TextField
    id="mealplan-operator-password"
    :name="`${formNamespace}keystore.operator_password`"
    :label="translate(`${LOCALE_PREFIX}.form.operatorPassword`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.operatorPasswordPlaceholder`)"
    :required="editMealPlan"
    :disabled="!editMealPlan"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);
const formNamespace = inject('formNamespace', '');
</script>
